
import { DialogType, DialogPositioningBehavior, DialogUserResizeMode } from '@tableau/widgets';
import React = require('react');
import { ServerSettingsUnauthenticated } from '../../settings/services/ServerSettingsUnauthenticated';
import { ModalInstance, ReactModalService } from '../../ts/services/ReactModalService';
import { BulkImportUserDialog } from '../components/BulkImportUserDialog';
import { Messages } from '../../codegen/Localize';

const Method ={
    ImportUsersFromCsv: 'importUsersFromCsv',
    ImportServerUsersFromCsv: 'importServerUsersFromCsv'
  };

function showBulkImportSiteUsersDialog(): ng.IPromise<any> {
    return showBulkImportUsersDialog(Method.ImportUsersFromCsv, ServerSettingsUnauthenticated.isSiteSamlEnabled());
}

function showBulkImportServerUsersDialog(): ng.IPromise<any> {
    return showBulkImportUsersDialog(Method.ImportServerUsersFromCsv, false);
}
function showBulkImportUsersDialog(method: string, showAuthSettingSelector: boolean): ng.IPromise<any> {
    let modalInstance: ModalInstance;
    const dialogProps = {
        dismiss: () => modalInstance && modalInstance.dismiss(),
        close: (result: any) => modalInstance && modalInstance.close(result),
        method: method,
        showAuthSettingSelector: showAuthSettingSelector
      };
    modalInstance = ReactModalService.open({
        type: DialogType.NormalWithTitleBar,
        dialogContent: React.createElement(BulkImportUserDialog, dialogProps),
        title: Messages.importUsers_ImportFromFile(),
        testId: 'bulkImportUsersDialog',
        showCloseButton: false,
        shouldNotSetDefaultWidth: true,
        positioningBehavior: DialogPositioningBehavior.Draggable
    });

    return modalInstance.result;
}

export const BulkImportUsersAction = {showBulkImportSiteUsersDialog, showBulkImportServerUsersDialog};